"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _polished = require("polished");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Flex = _interopRequireDefault(require("../Flex/Flex"));

var _excluded = ["id", "disabled", "label", "colour", "onChange", "checked"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var HiddenCheckbox = _styledComponents["default"].input.attrs({
  type: "checkbox"
}).withConfig({
  displayName: "Checkbox__HiddenCheckbox",
  componentId: "sc-1nckb67-0"
})(["", ""], (0, _polished.hideVisually)());

var Wrapper = (0, _styledComponents["default"])(_Flex["default"]).withConfig({
  displayName: "Checkbox__Wrapper",
  componentId: "sc-1nckb67-1"
})(["opacity:", ";cursor:", ";"], function (_ref) {
  var disabled = _ref.disabled;
  return disabled ? 0.6 : 1;
}, function (_ref2) {
  var disabled = _ref2.disabled;
  return disabled ? "not-allowed" : "auto";
});

var LabelWrapper = _styledComponents["default"].div.withConfig({
  displayName: "Checkbox__LabelWrapper",
  componentId: "sc-1nckb67-2"
})(["user-select:none;"]);

var CustomCheckbox = (0, _styledComponents["default"])(_Flex["default"]).withConfig({
  displayName: "Checkbox__CustomCheckbox",
  componentId: "sc-1nckb67-3"
})(["width:18px;height:18px;transition:0.18s;flex-shrink:0;background-image:", ";background-position:center;background-repeat:no-repeat;background-size:100%;&:hover{background-color:", ";}"], function (_ref3) {
  var isChecked = _ref3.isChecked;
  return isChecked ? "url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9IiNmZmZmZmYiIHN0cm9rZS13aWR0aD0iMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIj48cG9seWxpbmUgcG9pbnRzPSIyMCA2IDkgMTcgNCAxMiI+PC9wb2x5bGluZT48L3N2Zz4=)" : "none";
}, function (_ref4) {
  var theme = _ref4.theme,
      isChecked = _ref4.isChecked;
  return isChecked ? "none" : theme.colors.dark[5];
});

var Checkbox = function Checkbox(_ref5) {
  var id = _ref5.id,
      disabled = _ref5.disabled,
      _ref5$label = _ref5.label,
      Label = _ref5$label === void 0 ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null) : _ref5$label,
      colour = _ref5.colour,
      onChange = _ref5.onChange,
      checked = _ref5.checked,
      props = (0, _objectWithoutPropertiesLoose2["default"])(_ref5, _excluded);

  var _useState = (0, _react.useState)(checked),
      isChecked = _useState[0],
      setIsChecked = _useState[1];

  var handleChange = function handleChange(e) {
    setIsChecked(e.target.checked);
    onChange(e);
  };

  return /*#__PURE__*/_react["default"].createElement(Wrapper, (0, _extends2["default"])({
    disabled: disabled
  }, props, {
    as: "label"
  }), /*#__PURE__*/_react["default"].createElement(HiddenCheckbox, {
    id: id,
    checked: isChecked,
    disabled: disabled,
    onChange: function onChange(e) {
      return handleChange(e);
    }
  }), /*#__PURE__*/_react["default"].createElement(_Flex["default"], {
    alignItems: "flex-start",
    flexDirection: "row",
    width: "auto"
  }, /*#__PURE__*/_react["default"].createElement(CustomCheckbox, {
    isChecked: checked,
    bg: checked ? colour : "transparent",
    mr: 2,
    border: "2px solid",
    borderColor: checked ? "transparent" : colour,
    borderRadius: 3
  }), Label && /*#__PURE__*/_react["default"].isValidElement(Label) ? /*#__PURE__*/_react["default"].createElement(LabelWrapper, null, Label) : /*#__PURE__*/_react["default"].createElement(LabelWrapper, null, /*#__PURE__*/_react["default"].createElement(Label, null))));
};

Checkbox.propTypes = {
  onChange: _propTypes["default"].func.isRequired,
  id: _propTypes["default"].string.isRequired,
  disabled: _propTypes["default"].bool,
  colour: _propTypes["default"].string,
  checked: _propTypes["default"].bool
};
Checkbox.defaultProps = {
  disabled: false,
  colour: "primary.0",
  checked: false
};
var _default = Checkbox;
exports["default"] = _default;